import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const rawServerUrl = `${process.env.REACT_APP_SERVER_URL || ""}`.trim();
const isLocal8000 =
    /^(https?:\/\/)?(localhost|127\.0\.0\.1):8000\/?$/i.test(rawServerUrl) ||
    rawServerUrl.includes("localhost:8000") ||
    rawServerUrl.includes("127.0.0.1:8000");
const serverUrl = isLocal8000 ? "http://127.0.0.1:8001" : rawServerUrl;

const ConnectionTest = () => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");

    const runTest = async (path, method = "GET") => {
        setLoading(true);
        setError("");
        setResult(null);

        try {
            const url = `${serverUrl}${path}`;
            const res =
                method === "POST"
                    ? await axios.post(url, {}, { withCredentials: false })
                    : await axios.get(url, { withCredentials: false });
            setResult({
                status: res.status,
                data: res.data,
            });
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                    err?.response?.data?.error ||
                    err?.message ||
                    "Request failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-white px-6 py-12 text-slate-900">
            <div className="mx-auto w-full max-w-3xl rounded-2xl border border-slate-200 bg-slate-50 p-8">
                <h1 className="text-3xl font-semibold">Frontend-Backend Connection Test</h1>
                <p className="mt-3 text-base text-slate-700">
                    These send public unauthenticated requests to:
                    <code className="ml-1 rounded bg-slate-200 px-2 py-1 text-sm">
                        /public-test/connection
                    </code>
                    <span className="mx-1">and</span>
                    <code className="rounded bg-slate-200 px-2 py-1 text-sm">
                        /public-test/database
                    </code>
                    <span className="mx-1">and</span>
                    <code className="rounded bg-slate-200 px-2 py-1 text-sm">
                        /public-test/init-database
                    </code>
                    <span className="mx-1">and</span>
                    <code className="rounded bg-slate-200 px-2 py-1 text-sm">
                        /public-test/write-data
                    </code>
                </p>

                <div className="mt-6 flex flex-wrap gap-3">
                    <button
                        type="button"
                        onClick={() => runTest("/public-test/connection")}
                        disabled={loading}
                        className="rounded-lg bg-[#007BFF] px-5 py-2.5 text-white hover:bg-[#0056b3] disabled:cursor-not-allowed disabled:bg-slate-400"
                    >
                        {loading ? "Testing..." : "Test Frontend-Backend"}
                    </button>
                    <button
                        type="button"
                        onClick={() => runTest("/public-test/database")}
                        disabled={loading}
                        className="rounded-lg bg-[#0f766e] px-5 py-2.5 text-white hover:bg-[#115e59] disabled:cursor-not-allowed disabled:bg-slate-400"
                    >
                        {loading ? "Testing..." : "Test Backend-Database"}
                    </button>
                    <button
                        type="button"
                        onClick={() => runTest("/public-test/init-database", "POST")}
                        disabled={loading}
                        className="rounded-lg bg-[#b45309] px-5 py-2.5 text-white hover:bg-[#92400e] disabled:cursor-not-allowed disabled:bg-slate-400"
                    >
                        {loading ? "Running..." : "Init Database"}
                    </button>
                    <button
                        type="button"
                        onClick={() => {
                            if (!window.confirm("Write the glass/window seed data into the database?")) {
                                return;
                            }
                            runTest("/public-test/write-data", "POST");
                        }}
                        disabled={loading}
                        className="rounded-lg bg-[#7c3aed] px-5 py-2.5 text-white hover:bg-[#6d28d9] disabled:cursor-not-allowed disabled:bg-slate-400"
                    >
                        {loading ? "Writing..." : "Write Data"}
                    </button>
                    <Link
                        to="/"
                        className="rounded-lg border border-slate-300 bg-white px-5 py-2.5 text-slate-800 hover:bg-slate-100"
                    >
                        Back To Home
                    </Link>
                </div>

                {error ? (
                    <div className="mt-6 rounded-lg border border-red-300 bg-red-50 p-4 text-red-700">
                        {error}
                    </div>
                ) : null}

                {result ? (
                    <div className="mt-6 rounded-lg border border-emerald-300 bg-emerald-50 p-4">
                        <p className="font-medium text-emerald-800">Success (HTTP {result.status})</p>
                        <pre className="mt-3 overflow-auto rounded bg-white p-3 text-sm text-slate-800">
                            {JSON.stringify(result.data, null, 2)}
                        </pre>
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default ConnectionTest;
